<template>
  <FreeButton
    type="button"
    class="green-main-button flex w-full justify-center space-x-2"
  >
    <!-- prettier-ignore -->
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path fill="url(#a)" d="M9 14a5 5 0 0 0-5 5 3 3 0 0 0 3 3h10a3 3 0 0 0 3-3 5 5 0 0 0-5-5H9Z"/><path fill="#D5EBDD" d="M12 2a5 5 0 1 0 0 10 5 5 0 0 0 0-10Z"/><defs><linearGradient id="a" x1="7.17" x2="16.83" y1="23.41" y2="13.76" gradientUnits="userSpaceOnUse"><stop stop-color="#D5EBDD" stop-opacity=".3"/><stop offset="1" stop-color="#D5EBDD"/></linearGradient></defs></svg>
    <span>{{ t('passenger.select') }}</span>
  </FreeButton>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import { FreeButton } from '../../../shared/ui';

  const { t } = useI18n();
</script>

<i18n src="../locales.json"></i18n>
